<template>
  <div>
    <gg-card>
      <gg-card-header>Your IP Addresses</gg-card-header>
      <gg-card-text>
        <v-data-table
          :headers="headers"
          :items="hosting_detail.ips"
        >
          <template v-slot:item.actions="{ item }">
            <gg-btn @click="openEditDialog({ ip: item.ip, ptr: item.ptr })">
              Manage
            </gg-btn>
          </template>
        </v-data-table>
        <hosting-edit-ip-addr-form
          :ip_record="model.ip"
          :ptr_record="model.ptr"
          :service_id="model.service_id"
          :dialog-state="modal"
          @close="closeEditDialog"
        />
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HostingEditIpAddrForm from '@/components/Services/Hosting/HostingEditIpAddrForm'

export default {
  name: 'HostingIpAddrTable',
  components: {
    HostingEditIpAddrForm,
  },
  data: () => ({
    headers: [
      {
        text: 'IP Address',
        value: 'ip',
      },
      {
        text: 'PTR',
        value: 'ptr',
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'center',
        sortable: false,
      }
    ],
    model: {
      ip: '',
      ptr: '',
      service_id: ''
    },
    modal: false,
  }),
  computed: mapGetters(['hosting', 'hosting_detail']),
  methods: {
    ...mapActions(['getHostingDetail']),
    openEditDialog (item) {
      this.model.ip = item.ip
      this.model.ptr = item.ptr
      this.model.service_id = this.hosting.id
      this.modal = true
    },
    closeEditDialog () {
      this.modal = false
      for (let key in this.model) {
        this.model[key] = ''
      }
    },
  },
}
</script>
